import { HStack } from 'ui_2';

export const Socials = () => {
  return (
    <HStack className='gap-8 text-gray-500 '>
      <a
        href='https://discord.gg/puzzlearcade'
        target='_blank'
        className='text-black transition-colors hover:text-primary-orange'
        aria-label='Join the Puzzle Wallet Discord for support and news about the Puzzle Ecosystem!'
      >
        <svg
          className='center h-[35px] w-fit'
          stroke='currentColor'
          fill='currentColor'
          width='40'
          height='40'
          viewBox='0 0 41 40'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            d='M20.5455 0H20.4544C9.4339 0 0.5 8.93392 0.5 19.9545V20.0455C0.5 31.0661 9.4339 40 20.4544 40H20.5455C31.5661 40 40.5 31.0661 40.5 20.0455V19.9545C40.5 8.93392 31.5661 0 20.5455 0Z'
            fill='currentColor'
          />
          <path
            d='M30.5095 10.8173C28.6681 9.97229 26.6949 9.35007 24.6306 8.99412C24.5928 8.98711 24.5549 9.00393 24.5367 9.03896C24.2831 9.49021 24.0014 10.0802 23.8052 10.5427C21.5854 10.2105 19.3768 10.2105 17.2018 10.5427C17.0043 10.069 16.7128 9.49021 16.4577 9.03896C16.4381 9.00533 16.4003 8.98851 16.3638 8.99412C14.301 9.35007 12.3264 9.97229 10.485 10.8173C10.4696 10.8243 10.4555 10.8355 10.4457 10.851C6.7012 16.4453 5.67535 21.9024 6.17846 27.2921C6.18126 27.3188 6.19528 27.344 6.2163 27.3594C8.68695 29.1742 11.0806 30.2757 13.4293 31.0058C13.4671 31.017 13.5064 31.003 13.5302 30.9722C14.0852 30.214 14.5813 29.4138 15.0059 28.5716C15.0311 28.5226 15.0059 28.4637 14.9554 28.4441C14.1692 28.1456 13.4223 27.7826 12.702 27.3706C12.6445 27.337 12.6403 27.2557 12.6922 27.2164C12.8435 27.1029 12.9949 26.9852 13.1392 26.8661C13.1658 26.8437 13.2023 26.8395 13.2331 26.8535C17.96 29.0116 23.0779 29.0116 27.7487 26.8535C27.7796 26.8381 27.816 26.8437 27.8426 26.8647C27.987 26.9838 28.1383 27.1029 28.2911 27.2164C28.3429 27.2557 28.3401 27.337 28.2827 27.3706C27.5638 27.791 26.8154 28.147 26.0278 28.4441C25.976 28.4637 25.9535 28.5226 25.9788 28.573C26.4132 29.4124 26.9079 30.2126 27.453 30.9722C27.4755 31.0044 27.5161 31.0184 27.5539 31.0072C29.9139 30.2771 32.3075 29.1756 34.7781 27.3608C34.7992 27.3454 34.8132 27.3201 34.816 27.2949C35.4186 21.0643 33.807 15.6521 30.5459 10.8538C30.5375 10.8384 30.5249 10.8257 30.5081 10.8187L30.5095 10.8173ZM15.7093 24.0101C14.2855 24.0101 13.114 22.704 13.114 21.0994C13.114 19.4948 14.2645 18.1887 15.7093 18.1887C17.1542 18.1887 18.3286 19.5074 18.3047 21.0994C18.3047 22.704 17.1542 24.0101 15.7093 24.0101ZM25.3075 24.0101C23.8837 24.0101 22.7121 22.704 22.7121 21.0994C22.7121 19.4948 23.8627 18.1887 25.3075 18.1887C26.7523 18.1887 27.9267 19.5074 27.9029 21.0994C27.9029 22.704 26.7649 24.0101 25.3075 24.0101Z'
            fill='#FEFFFC'
          />
        </svg>
      </a>
      <a
        href='https://twitter.com/lets_puzzle'
        target='_blank'
        className='self-center text-black transition-colors hover:text-primary-orange'
        aria-label='Follow the Puzzle Wallet Twitter news about the Puzzle Ecosystem!'
      >
        <div className='w-9 rounded-full bg-black p-2 transition-colors hover:bg-primary-orange'>
          <svg
            className='center h-[19px] w-[19px]'
            stroke='currentColor'
            fill='currentColor'
            width='300'
            height='300.251'
            viewBox='0 0 300 300'
            preserveAspectRatio='xMidYMid meet'
            version='1.1'
            xmlns='http://www.w3.org/2000/svg'
          >
            <path
              d='M178.57 127.15 290.27 0h-26.46l-97.03 110.38L89.34 0H0l117.13 166.93L0 300.25h26.46l102.4-116.59 81.8 116.59h89.34M36.01 19.54H76.66l187.13 262.13h-40.66'
              fill='#FEFFFC'
            />
          </svg>
        </div>
      </a>
      <a
        href='https://github.com/puzzlehq/puzzle-sdk'
        target='_blank'
        className='text-black transition-colors hover:text-primary-orange'
        aria-label='Check out the Puzzle Wallet Github for all our latest open-source code!'
      >
        <svg
          className='center h-[35px] w-fit'
          stroke='currentColor'
          fill='currentColor'
          width='40'
          height='40'
          viewBox='0 0 41 40'
          xmlns='http://www.w3.org/2000/svg'
        >
          <circle cx='20.5' cy='20' r='20' fill='#FEFFFC' />
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M20.5 0C9.45 0 0.5 8.99285 0.5 20.0958C0.5 28.9881 6.225 36.4989 14.175 39.1616C15.175 39.3375 15.55 38.7346 15.55 38.2071C15.55 37.7298 15.525 36.1472 15.525 34.4642C10.5 35.3937 9.2 33.2334 8.8 32.103C8.575 31.5252 7.6 29.7417 6.75 29.2645C6.05 28.8877 5.05 27.9582 6.725 27.9331C8.3 27.908 9.425 29.39 9.8 29.9929C11.6 33.0324 14.475 32.1783 15.625 31.6508C15.8 30.3446 16.325 29.4654 16.9 28.963C12.45 28.4606 7.8 26.7274 7.8 19.0407C7.8 16.8553 8.575 15.0467 9.85 13.64C9.65 13.1376 8.95 11.0778 10.05 8.31462C10.05 8.31462 11.725 7.78711 15.55 10.3744C17.15 9.92228 18.85 9.6962 20.55 9.6962C22.25 9.6962 23.95 9.92228 25.55 10.3744C29.375 7.76199 31.05 8.31462 31.05 8.31462C32.15 11.0778 31.45 13.1376 31.25 13.64C32.525 15.0467 33.3 16.8302 33.3 19.0407C33.3 26.7525 28.625 28.4606 24.175 28.963C24.9 29.591 25.525 30.7968 25.525 32.6807C25.525 35.3685 25.5 37.5288 25.5 38.2071C25.5 38.7346 25.875 39.3626 26.875 39.1616C34.775 36.4989 40.5 28.963 40.5 20.0958C40.5 8.99285 31.55 0 20.5 0V0Z'
          />
        </svg>
      </a>
    </HStack>
  );
};
